module.exports = __webpack_public_path__ + "static/us-flag-c2a3a7e1f5ea5c3e0d6fce462fec7a99.png";